// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import {
  SAVE_USERPROFILE,
  SAVE_SITEDATA,
  ADD_STEM_ID,
  CREATE_STEM,
  SHOW_ADD_STEM_ERROR,
  SET_STEM_NAME,
  SET_STEM_LOCATION,
  HIDE_TOAST
} from '../actions/actions';
// import convertTimestamps from '../utils/ConvertTimestamps';
import { saveInSession, getFromSession } from '../utils/Utility';
let sites = getFromSession('sites');
const initialState = {
  sites: sites ? sites : [],
  twigId: '',
  stemDetails: '',
  showStemAddForm: false,
  showToast: false,
  toastMessage: '',
  showAddStemError : null,
  stemName: '',
  stemLocation: ''
};

const handlers = {

  [SAVE_SITEDATA]: (state, action) => {
    saveInSession('sites', action.result);
    return {
      sites: action.result
    };
  },
  [ADD_STEM_ID]: (state, action) => {
    return {
      twigId: action.result.data[0].twigId,
      showStemAddForm: action.result.success
    }
  },
  [CREATE_STEM]: (state, action) => {
    return {
      stemDetails: action.result.data,
      showStemAddForm: !action.result.success,
      showToast: true,
      toastMessage: action.result.message,
    }
  },

  [SHOW_ADD_STEM_ERROR] : (state, action) => {
    return {
      showAddStemError : action.result
    }
  },

  [SET_STEM_NAME] : (state, action) => {
    return {
      stemName : action.result
    }
  },

  [SET_STEM_LOCATION] : (state, action) => {
    return {
      stemLocation : action.result
    }
  },

  [HIDE_TOAST]: (state, action) => {
    return {
      showToast: false,
    }
  }

};

export default function dashboardReducer(state = initialState, action) {
  let handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
};



// WEBPACK FOOTER //
// ./src/js/reducers/dashboard.js